import React from "react";
import Box from "@mui/material/Box";
import DashboardContentLayout from "@app.automotus.io/components/Layout/DashboardContentLayout";

export const TransactionSummaryLayout: React.FC = ({ children }) => {
  return (
    <Box sx={{ bgcolor: "background.default" }}>
      <DashboardContentLayout sx={{ my: { xs: 4, lg: 8 } }}>{children}</DashboardContentLayout>
    </Box>
  );
};

export default TransactionSummaryLayout;
